import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IPricingList } from "../../../Pages/Pricing/IPricing"

interface IUpdate extends IReduxState<IPricingList> {
  updateableDate?: IPricingList;
}

export const UpdatePricingSlicer = createSlice({
  name: "UpdatePricing",
  initialState: {
    data: {},
    isLoading: false,
    updateableDate: {},
  } as IUpdate,
  reducers: {
    updatePricing: (state, _) => {
      state.isLoading = true;
    },
    successUpdatePricing: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureUpdatePricing: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearUpdatePricingState: (state) => {
      state.data = {};
      state.updateableDate = undefined;
    },
    PricingUpdateableData: (state, action) => {
      state.updateableDate = action.payload;
    },
    clearUpdateableData: (state) => {
      state.updateableDate = undefined;
    },
  },
});

export const {
  updatePricing,
  successUpdatePricing,
  failureUpdatePricing,
  clearUpdatePricingState,
  PricingUpdateableData,
  clearUpdateableData
} = UpdatePricingSlicer.actions;

export default UpdatePricingSlicer.reducer;
